module.exports = __webpack_public_path__ + "img/certificate1.a7a5a470.jpg";